// import { Dropdown, Flex, Image } from "antd"
// import { MdOutlineArrowDropDown } from "react-icons/md"
// import { useDispatch, useSelector } from "react-redux";
// import { NavLink } from "react-router-dom"
// import { setCurrentLang } from "../Store/user/UserSlice";
// import imageEn from '../assets/images/en.png';
// import imageAr from '../assets/images/ar.png';

// export const NavLinksItems = ({t,onClose}) => {
//     const dispatch = useDispatch();
//     const {currentLang} = useSelector(state => state.user);
//         const items = [
//           {
//             key: 'en',
//             label: 'English',
//             icon: <Image src={imageEn} preview={false}
//              width={20}
//              height={20}
//              style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//              }}
//             />,
//           },
//           {
//             key: 'ar',
//             label: 'العربية',
//             icon: <Image src={imageAr} preview={false}
//              width={20}
//              height={20}
//              style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//              }}
//             />,
//           },
//         ];
//         const chanageLang = ({ key }) => {
//             console.log(key);
//             dispatch(setCurrentLang(key));
//             document.getElementsByTagName('html')[0].setAttribute('lang', key);
//           };
//     return (
//         <>
//           <NavLink
//           to="/"
//           onClick={onClose}
//           className={({ isActive }) => (isActive ? 'activeLink link-header ' : 'link-header')}>
//             {t.home}
//         </NavLink>
//           <NavLink
//           to="/services"
//           onClick={onClose}
//           className={({ isActive }) => (isActive ? 'activeLink link-header' : 'link-header')}>
//             {t.Services}
//         </NavLink>
//           <NavLink
//           to="/experience"
//           onClick={onClose}
//           className={({ isActive }) => (isActive ? 'activeLink link-header' : 'link-header')}>
//             {t.ExperienceGallery}
//         </NavLink>
//           <NavLink
//           to="/about"
//           onClick={onClose}
//           className={({ isActive }) => (isActive ? 'activeLink link-header' : 'link-header')}>
//             {t.AboutUs}
//         </NavLink>
//         <Dropdown
//             overlayClassName="lang-dropdown"
//             placement="bottom"
//             arrow={{ pointAtCenter: true }}
//             trigger={['hover']}
//             // overlayStyle={{ top: '80px' }}
//             // arrow
//             menu={{ items: items, onClick: chanageLang }}
//           >
//               <span className="lang-text"
//                 style={{ cursor: 'pointer' }}
//               >
//                 <Flex align="center" gap={12}>
//                   <span
//                     style={{
//                       fontSize: '16px',
//                       fontWeight: '500',
//                       cursor: 'pointer',
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >

//                   {currentLang === 'en' ? 'En' : 'اللغة'}
//                   </span>
//                   <Image preview={false} src={ currentLang === 'en' ? imageEn : imageAr}
//                   style={{ width: '25px', height: '25px',
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center"}}
//                   />
//                   <MdOutlineArrowDropDown
//                     size={20}
//                     style={{ width: '25px', height: '25px',
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center"}}
//                   />
//                 </Flex>
//               </span>
//            </Dropdown>
//         </>
//     )
// }

import { Dropdown, Flex, Image } from 'antd';
import { MdOutlineArrowDropDown } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { setCurrentLang } from '../Store/user/UserSlice';
import imageEn from '../assets/images/en.png';
import imageAr from '../assets/images/ar.png';

export const NavLinksItems = ({ t, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { currentLang } = useSelector((state) => state.user);

  const items = [
    {
      key: 'en',
      label: 'English',
      icon: <Image src={imageEn} preview={false} width={20} height={20} />,
    },
    {
      key: 'ar',
      label: 'العربية',
      icon: <Image src={imageAr} preview={false} width={20} height={20} />,
    },
  ];

  const changeLang = ({ key }) => {
    dispatch(setCurrentLang(key));
    document.getElementsByTagName('html')[0].setAttribute('lang', key);

    // const newPath = location.pathname.replace(`/${currentLang}`, `/${key}`);
    // navigate(newPath, { replace: true });
    navigate(key === 'en' ? '/' : `/${key}`);
  };

  return (
    <>
      <NavLink
        to={currentLang === 'en' ? '/' : '/ar'}
        onClick={onClose}
        className={({ isActive }) => {
          const pathMatch =
            location.pathname === (currentLang === 'en' ? '/' : '/ar');
          return pathMatch ? 'activeLink link-header' : 'link-header';
        }}
      >
        {t.home}
      </NavLink>
      <NavLink
        to={currentLang === 'en' ? '/services' : '/ar/services'}
        onClick={onClose}
        className={({ isActive }) => {
          const pathMatch =
            location.pathname ===
            (currentLang === 'en' ? '/services' : '/ar/services');
          return pathMatch ? 'activeLink link-header' : 'link-header';
        }}
      >
        {t.Services}
      </NavLink>
      <NavLink
        to={currentLang === 'en' ? '/projects' : '/ar/projects'}
        onClick={onClose}
        className={({ isActive }) => {
          const pathMatch =
            location.pathname ===
            (currentLang === 'en' ? '/projects' : '/ar/projects');
          return pathMatch ? 'activeLink link-header' : 'link-header';
        }}
      >
        {t.Projects}
      </NavLink>
      <NavLink
        to={currentLang === 'en' ? '/about' : '/ar/about'}
        onClick={onClose}
        className={({ isActive }) => {
          const pathMatch =
            location.pathname ===
            (currentLang === 'en' ? '/about' : '/ar/about');
          return pathMatch ? 'activeLink link-header' : 'link-header';
        }}
      >
        {t.AboutUs}
      </NavLink>
      {/* <Dropdown
        overlayClassName="lang-dropdown"
        placement="bottom"
        arrow={{ pointAtCenter: true }}
        trigger={['hover']}
        menu={{ items: items, onClick: changeLang }}
      >
        <span className="lang-text" style={{ cursor: 'pointer' }}>
          <Flex align="center" gap={12}>
            <span
              style={{
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
              }}
            >
              {currentLang === 'en' ? 'En' : 'اللغة'}
            </span>
            <Image
              preview={false}
              src={currentLang === 'en' ? imageEn : imageAr}
              style={{ width: '25px', height: '25px' }}
            />
            <MdOutlineArrowDropDown
              size={20}
              style={{ width: '25px', height: '25px' }}
            />
          </Flex>
        </span>
      </Dropdown> */}
    </>
  );
};
